let storage;
if (typeof localStorage === 'undefined' || localStorage === null) {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const { LocalStorage } = require('node-localstorage');
    storage = new LocalStorage('./cache');
}
else {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    // const { localStorage } = require('mp-storage');
    storage = localStorage;
}
export default storage;
//# sourceMappingURL=storage.js.map